import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { Icon } from '../../../components';
import PressureTest from './pressure-test/pressureTest';

const TestingDashboard = ({ activePublishersResult, archivedPublishersResult, showCreateModal, hideCreateModal, showingCreateModal }) => (
  <div className='base-layout'>
    <section className='layout--header'>
      <Grid>
        <Row className='button-gutter'>
          <Col xs={12}>
            <h1>Testing admin</h1>
          </Col>
        </Row>
      </Grid>
    </section>
    <section className='layout--section'>
      <Grid>
        <section className='testing--dashboard'>
          <Row className='xs-gutter'>
            <Col xs={12} md={9}>
              <h2><Icon icon='caddie-links-large-alt' /> Tests</h2>
              <p>Perform tests.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <PressureTest />
            </Col>
          </Row>
        </section>
      </Grid>
    </section>
  </div>
)

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {

    }
  })
)(TestingDashboard)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/testing.js